import React from 'react';
import CloudinaryAdvancedImage from '@common/utils/CloudinaryAdvancedImage';
import { Link } from 'react-router-dom';


function index({ productImage, productName, productPrice, productLink }) {

    const formatINR = (amount) => {
        return new Intl.NumberFormat('en-IN', {
            style: 'currency',
            currency: 'INR',
            maximumFractionDigits: 0,
        }).format(amount);
    };

    return (
        <div className='mod-search-item'>
            <Link to={productLink} className='mod-search-item__link'></Link>
            <div className='mod-search-item__img-wrap'>
                <CloudinaryAdvancedImage imagePublicId={productImage} className='mod-search-item__image' type="product-main" />
            </div>
            <div className='mod-search-item__info-wrap'>
                <h3 className='mod-search-item__title'>{productName}</h3>
                <p className='mod-search-item__desc'> {formatINR(productPrice)}</p>
            </div>
        </div>
    )
}

export default index